import { SpineAnimation } from '@base/spineAnimation/SpineAnimation'
import Facade from '../../Facade'

export const resolveLogoAnimationByLocale = (): string => {
    const rawLocale = ((Facade.urlParams as any)?.language || 'en').toString().trim().toLowerCase()
    const normalizedLocale = rawLocale.split('-')[0]

    if (normalizedLocale === 'zh' || normalizedLocale === 'cn') {
        return 'CH'
    }

    return 'EN'
}

export const startLogoAnimation = (container: SpineAnimation): void => {
    const animationName = resolveLogoAnimationByLocale()

    try {
        container.start([animationName], [true], 0, [1])
    } catch (error) {
        container.start(['EN'], [true], 0, [1])
    }
}
